export default {
    listMailTrash: [],
    searchFilter: null,
    mode: false,
}